import { createRelayResource } from '@atlassian/help-center-common-util/resource-router/resource-router';
import type { csmFolderSearchArticlesForSupportSiteQuery } from '../../ui/__generated__/csmFolderSearchArticlesForSupportSiteQuery.graphql';
import CsmFolderSearchQuery from '../../ui/__generated__/csmFolderSearchArticlesForSupportSiteQuery.graphql';
import { MAX_ITEMS_PER_PAGE } from '../../ui/types';

const ANCESTORS = 'ANCESTORS';

export const CsmFolderResource = createRelayResource<csmFolderSearchArticlesForSupportSiteQuery>({
	type: 'CSM_FOLDER',
	getQuery: ({ match }, { cloudId, helpCenterAri }) => {
		const pageId = match.params.folderId || '';
		return {
			parameters: CsmFolderSearchQuery,
			variables: {
				cloudId,
				helpCenterAri,
				first: MAX_ITEMS_PER_PAGE,
				input: {
					parentId: Number(pageId),
					expand: [ANCESTORS],
				},
			},
			options: {
				fetchPolicy: 'store-or-network',
			},
		};
	},
});
